module.exports = __webpack_public_path__ + "img/1411700356.43ec2a15.jpg";